import React from 'react'
import { useState, useRef, useEffect } from 'react'
import AccoundDropdown from './AccoundDropdown'
import { FaUserCircle } from 'react-icons/fa';
import useUser from '../Hooks/useUser';


function AccountConfig() {

    const [isOpen, setIsOpen] = useState(false)
    const dropdownRef = useRef(null)
    const userState = useUser()

    useEffect(() => {
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false)
            }
        }

        document.addEventListener('mousedown', handleClickOutside)
        return () => document.removeEventListener('mousedown', handleClickOutside)
    }, [])

    return (
        <div
            className='relative group'
            ref={dropdownRef}
            onMouseEnter={() => setIsOpen(true)}
            onMouseLeave={() => setIsOpen(false)}
        >
            <button
                onClick={() => setIsOpen(!isOpen)}
                className='flex items-center gap-2 px-3 py-2 text-white font-body hover:text-white transition-colors rounded-lg hover:bg-white hover:bg-opacity-10 cursor-pointer'
                aria-label="Profile menu"
            >
                <FaUserCircle size={20} />
                <span className='text-base'>{userState.userId ? 'Conta' : 'Login'}</span>
            </button>
            {isOpen && (
                <div className='absolute z-50 right-0 top-full pt-1'>
                    <AccoundDropdown />
                </div>
            )}
        </div>
    )
}

export default AccountConfig